import AddressProofModal from './AddressProofModal';

export default AddressProofModal;
